
var validator = require('validator');
var stringUtil = require('../string/stringUtil.js');

module.exports.isNumeric = function(value)
{
    value = value + "";
    if (stringUtil.isStringNullOrEmpty(value))
        return false;

    var options = {};
    options.force_decimal = false;
    return validator.default.isFloat(value, options)
}

module.exports.isGreaterThanOrEqualToZero = function(value)
{
    return this.isNumeric(value) && Number(value) >= 0;
}

module.exports.isGreaterThanZero = function (value)
{
    return this.isNumeric(value) && Number(value) > 0;
}

module.exports.isBetween = function (value, lower, upper)
{
    return (
        this.isNumeric(value) &&
        this.isNumeric(lower) &&
        this.isNumeric(upper) &&
        lower <= upper &&
        value >= lower &&
        value <= upper);
}

module.exports.isInteger = function(value)
{
    value = value + "";
    if (stringUtil.isStringNullOrEmpty(value))
        return false;

    return validator.default.isInt(value)
}

module.exports.formatPhoneNumber = function (phoneNumber, country)
{
    let countryCode = "44";
    if(country === "Pakistan")
        countryCode = "92";
    else if(country === "Ireland")
        countryCode = "353";
    else if(country === "Kenya")
        countryCode = "254";

    phoneNumber = stringUtil.trimString(phoneNumber);
    if (!phoneNumber || phoneNumber == "")
        return "";
    
    phoneNumber = stringUtil.replaceAll(phoneNumber, " ", "");
    phoneNumber = stringUtil.replaceAll(phoneNumber, ")", "");
    phoneNumber = stringUtil.replaceAll(phoneNumber, "(", "");
    phoneNumber = stringUtil.replaceAll(phoneNumber, "+", "");

    while(phoneNumber.startsWith("0"))
        phoneNumber = phoneNumber.slice(1);
        
    if (!phoneNumber.startsWith(countryCode))
        phoneNumber = countryCode + phoneNumber;
   
    if (isNaN(phoneNumber))
        return "";
    
    if (phoneNumber.length != 12)
        return "";

    return phoneNumber;
}

module.exports.isObject = function (value)
{
    return value != null && typeof value === "object" && !Array.isArray(value);
}

module.exports.isEmptyObject = function (value)
{
    return this.isObject(value) && Object.keys(value).length === 0;
}